export default "<app-demo-viewer [screenId]=\"screenId\" [dateTime]=\"dateTime\" [imageUrl]=\"imageUrl\"></app-demo-viewer>"